'use client';

import { css } from '@bts-web/utils-style-engine';
import { NavigationBackButton } from '../../navigation';
import { NavigationBar } from '../../common';
import { useRouter, useSearchParams } from 'next/navigation';

export const SavingsPlansListNavBar = ({
  translations,
}: {
  translations: { savingsPlans: string };
}) => {
  const router = useRouter();

  const searchParams = useSearchParams();

  const assetId = searchParams?.get('assetId');

  const goToPortfolioOrBack = () => {
    if (assetId) {
      router.back();
    } else {
      router.push('/portfolio');
    }
  };

  return (
    <div
      className={css({
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'screen_background.primary',
        position: 'sticky',
        top: 0,
        width: '100%',
        '& nav': {
          width: '100%',
        },
      })}
    >
      <NavigationBar
        title={translations.savingsPlans}
        NavigationLeftSlot={
          <NavigationBackButton handleVirtualNavigation={goToPortfolioOrBack} />
        }
      />
    </div>
  );
};
